
import React from 'react';

import Carousel from './Carousel';


const slides = [
    {
        title: 'Not Every Child Needs to Be a Scientist',
        subtitle: 'But every child deserves the habit of scientific thinking — to question, observe, and understand the world.',
        background: '/assets/home/carousel/carousel_1.jpg',
    },
    {
        title: 'Learning Is Not Transferred. It Is Discovered',
        subtitle: 'When learners are actively engaged, their ability to learn comes alive.',
        background: '/assets/home/carousel/carousel_2.jpg',
    },
    {
        title: 'Great Classrooms Begin with Supported Teachers',
        subtitle: 'Sci Sab enables teachers with research-backed content, tools, and training — not added burden.',
        background: '/assets/home/carousel/carousel_3.jpg',
    },
    {
        title: 'Building Thinkers for an Uncertain Future',
        subtitle: 'Science and Mathematics for K–10 — rooted in curiosity, enquiry, and real understanding.',
        background: '/assets/home/carousel/carousel_4.jpg',
    },
];


const HeroSection = (props) => {

    return (
        <Carousel slides={slides} />
    );




}

export default HeroSection;